import {Button} from '@wandb/components';
import React, {FC} from 'react';
import {toast} from 'react-toastify';

import {envIsLocal} from '../config';
import {useTriggerParquetExportMutation} from '../generated/graphql';
import {useAdminModeActive} from '../util/admin';

type RunTriggerParquetExportProps = {
  runID: string;
};

export const isParquetExportAllowed = (isAdmin: boolean) => {
  return !envIsLocal && isAdmin;
};

export const RunTriggerParquetExport: FC<RunTriggerParquetExportProps> = ({
  runID,
}: RunTriggerParquetExportProps) => {
  const isAdmin = useAdminModeActive();
  const [triggerParquetExport] = useTriggerParquetExportMutation();

  if (!isParquetExportAllowed(isAdmin)) {
    return null;
  }

  const onClick = async () => {
    try {
      const response = await triggerParquetExport({
        variables: {runId: runID},
      });
      if (response.errors != null) {
        toast('error triggering parquet export');
        return;
      }
      const taskID = response.data?.triggerParquetExport?.task?.id;
      if (taskID != null) {
        toast(`succesfully triggered parquet export ${taskID}`);
      }
    } catch (err) {
      toast(`error triggering parquet export ${err}`);
    }
  };

  return (
    <Button size="sm" onPress={onClick}>
      Trigger
    </Button>
  );
};
